import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiSymbolsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_symbols"}/>
}
